import logo from './logo.svg';
import './App.css';
import LandingPage from './components/LandingPage';
import Component1 from './components/Component1';
import Navigation from './components/Navigation';
import Telefoni from './components/Telefoni';
import TelefoniPRS from './components/TelefoniPRS';
import Telefoni_0800_072 from './components/Telefoni_0800_072';

import PrimarnaPRS from './components/PrimarnaPRS';
import Primarna0800 from './components/Primarna0800';

import Analiza from './components/Analiza';

import TelefonskiImenik from './components/TelefonskiImenik';
import DnevnepromjeneDonat from './components/DnevnepromjeneDonat';
import DnevnePromjeneA1 from './components/DnevnePromjeneA1';
import DnevnePromjeneFiksni from './components/DnevnePromjeneFiksni';
import DnevnePromjeneTele2 from './components/DnevnePromjeneTele2';
import DnevnepromjeneTMobile from './components/DnevnepromjeneTMobile'

import AdminDaily from './components/AdminDaily'
import AdminNumeration from './components/AdminNumeration'

import Pocetna from './components/Pocetna';

import BadData from './components/BadData';

import NadzoriUpravljanjeDnevnimSpiskovima from './components/NadzoriUpravljanjeDnevnimSpiskovima';
import Sifrator from './components/Sifrator';
import BijeleStranice from './components/BijeleStranice';
import ZuteStranice from './components/ZuteStranice';

import NadzorTKoperatora from './components/NadzorTKoperatora';
import Statistika from './components/Statistika';
import React, {useEffect, useState} from "react";
import Login from './components/Login'
import ChangePassword from './components/ChangePassword';


import store from './components/redux/store'
import { useSelector, useDispatch } from 'react-redux'
import * as useLocalStorage from './components/services/useLocalStorage'
import Loader3 from './components/Loader3';
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Routes,
  Route,
  Link,
  BrowserRouter
} from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WorkInProgress from './components/WorkInProgress';

function App() {
  
  
  const token = useSelector((state) =>useLocalStorage.getItem("token"))

  const workON = false;

  const dispatch = useDispatch()
  const isLoading = useSelector(state=> state.loader ? state.loader.isLoading: false)
const router = createBrowserRouter([
   
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/Component1",
      element: <Component1 />,
    },
  ]);



  
  if(!token) {
    console.log("app.js no token", token)

    if(workON){

      return (
        <div className="daisy-app" style={{height:"100vh"}}>
                      <ToastContainer
                           position="top-center"
                           autoClose={5000}
                           hideProgressBar={false}
                           newestOnTop={false}
                           closeOnClick
                           rtl={false}
                           pauseOnFocusLoss
                           draggable
                           pauseOnHover
                           theme="colored"
                   />     
           <BrowserRouter>
           <Navigation />
             <Routes>
               <Route path="/*" element={<WorkInProgress />} />

              
   
             </Routes>
           </BrowserRouter>
           <div className='version'>
            2025.08.22. - 05:00
                                               
               </div>
        </div>
       );

    }else {

    return (
     <div className="daisy-app" style={{height:"100vh"}}>
                   <ToastContainer
                        position="top-center"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                />     
        <BrowserRouter>
        <Navigation />
          <Routes>
            <Route path="/*" element={<Login />} />
            <Route path="/login/*" element={<Login />} />  
            <Route path="/changepassword/*" element={<ChangePassword />} />  
           

          </Routes>
        </BrowserRouter>
        <div className='version'>
        2025.08.22. - 05:00
                                            
            </div>
     </div>
    );
  }
  } else if (token) {
    console.log("app.js yes token", token)
    return (
      <div className="daisy-app" style={{height:"100vh"}}>
          <div className="loader-container" style={{visibility:isLoading ? "hidden" : "visible"}}>
                <Loader3 />
          </div>

          <ToastContainer
                        position="top-center"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                />              
         <BrowserRouter>
        <Navigation />
        <div class="val-body">
         <Routes>
           <Route path="/" element={<Pocetna />} />
           <Route path="/Telefoni" element={<Telefoni />} />
           <Route path="/TelefoniPRS" element={<TelefoniPRS />} />
           <Route path="/Telefoni_0800_072" element={<Telefoni_0800_072 />} />
           <Route path="/TelefonskiImenik" element={<TelefonskiImenik />} />
           <Route path="/DnevnepromjeneDonat" element={<DnevnepromjeneDonat />} />
           <Route path="/DnevnepromjeneTMobile" element={<DnevnepromjeneTMobile />} />
           <Route path="/DnevnePromjeneA1" element={<DnevnePromjeneA1 />} />
           <Route path="/DnevnePromjeneTele2" element={<DnevnePromjeneTele2 />} />
           <Route path="/DnevnePromjeneFiksni" element={<DnevnePromjeneFiksni />} />
           <Route path="/NadzoriUpravljanjeDnevnimSpiskovima" element={<NadzoriUpravljanjeDnevnimSpiskovima />} />
           <Route path="/Sifrator" element={<Sifrator />} />
           <Route path="/Bijelestranice" element={<BijeleStranice />} />
           <Route path="/ZuteStranice" element={<ZuteStranice />} />
           <Route path="/NadzorTKoperatora" element={<NadzorTKoperatora />} />
           <Route path="/PrimarnaPRS" element={<PrimarnaPRS />} />
           <Route path="/Primarna0800" element={<Primarna0800 />} />
           <Route path="/Analiza" element={<Analiza />} />
           <Route path="/BadData" element={<BadData />} />
           <Route path="/Statistika" element={<Statistika />} />
           <Route path="/AdminDaily" element={<AdminDaily />} />
           <Route path="/AdminNumeration" element={<AdminNumeration />} />

           
           <Route path="/*" element={<Pocetna />} />
           
           {/*Sifrator
           NadzoriUpravljanjeDnevnimSpiskovima*/}
         </Routes>

        </div>

       </BrowserRouter>
      </div>
     );
   }
}

export default App;
